import type { TAutocompleteOption } from '~/components/AutocompleteField/types.ts';

export enum GuaranteesManagerTermsFieldName {
  BeneficiarySanctionsStatus = 'beneficiarySanctionsStatus',
  DebtType = 'debtType',
}

export type TGuaranteesManagerTermsFormValues = {
  [GuaranteesManagerTermsFieldName.BeneficiarySanctionsStatus]: TAutocompleteOption | null;
  [GuaranteesManagerTermsFieldName.DebtType]: string;
};
